import React, { useState, useEffect } from "react";
import ChatBot from "react-simple-chatbot";
import "./chatbot.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Fade from "@material-ui/core/Fade";

const steps = [
  {
    id: "0",
    message: "Hello! I am CA Jarvis",
    trigger: "1",
  },
  {
    id: "1",
    message: "How can I help you?",
    end: true,
  },
];

const ShowBot = (props) => {
  return (
    <div data-aos="fade-up-left" className="fixed_btn bot_big_bg">
      <p onClick={props.RemoveShow}>
        <i className="fas fa-times" /> close
      </p>
      <ChatBot steps={steps} />
    </div>
  );
};

const Chatbot = () => {
  const [show, setShow] = useState(false);

  const RemoveShow = () => {
    setShow(!show);
  };
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);

  return (
    <div>
      {show ? (
        <ShowBot RemoveShow={RemoveShow} />
      ) : (
        <Fade in={true}>
          <p className="fixed_btn bot_small_bg" onClick={(e) => setShow(!show)}>
            <i className="fas fa-comment-alt" />
          </p>
        </Fade>
      )}
    </div>
  );
};

export default Chatbot;
